import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./slices/user";
import { videoSlice } from "./slices/video";
import { chatSlice } from "./slices/chat";
import type { AppDispatch, RootState } from "../types/store";
import thunk from "./thunk";
import { schedulesSlice } from "./slices/scheduler";

const store = configureStore({
  reducer: {
    [userSlice.name]: userSlice.reducer,
    [videoSlice.name]: videoSlice.reducer,
    [chatSlice.name]: chatSlice.reducer,
    [schedulesSlice.name]: schedulesSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    thunk: {
      extraArgument: thunk,
    },
  })
});

export { store };

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
